import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

export const getSvgString = (SvgImg, color) => {
  const CustomComp = SvgImg;

  return encodeURIComponent(renderToStaticMarkup(<CustomComp color={color} />));
};
